const SET_SNACKBAR = 'SET_SNACKBAR'
const SET_LOADING = 'SET_LOADING'
const SET_RELOAD_CALL = 'SET_RELOAD_CALL'

const state = {
  snackmsg: '',
  snackstatus: '',
  snackloading: false,
  loading: {
    state: false,
    msg: ''
  },
  user: {},
  reloadCall: false
}

const getters = {
  snackmsg: state => state.snackmsg,
  snackstatus: state => state.snackstatus,
  snackloading: state => state.snackloading,
  loading: state => state.loading,
  user: state => state.user,
  reloadCall: state => state.reloadCall
}

const mutations = {
  [SET_SNACKBAR]: (state, data) => {
    state.snackmsg = data.msg
    state.snackstatus = data.status
    state.snackloading = data.loading || false
  },
  [SET_LOADING]: (state, data) => {
    state.loading = data
  },
  [SET_RELOAD_CALL]: (state, data) => {
    state.reload = data.reload
    state.reload_2 = data.reload_2
    // this.$store.commit('general/SET_FETCH_REFRESH', { reload: false, reload_2: true })
  }
}

export { state, getters, mutations }
